import { useCallback, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import * as animationActions from "@/lib/state/actions/animation-actions";
import * as editorActions from "@/lib/state/actions/editor-actions";
import { EDITOR_DB_SAVE_STATE } from "@/lib/state/reducers/editor-reducer";
import { animationSelector } from "@/lib/state/selectors/animation-selector";
import { useAppDispatch } from "@/lib/state/store";

const LOCAL_SAVE_DELAY = 5000;

export const useAutosave = ({ enabled }: { enabled: boolean }) => {
  const animation = useSelector(animationSelector);
  const saveTimer = useRef<NodeJS.Timeout>(undefined);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(editorActions.setDbSaveState(EDITOR_DB_SAVE_STATE.QUEUED));

    if (enabled) {
      saveTimer.current = setTimeout(() => {
        dispatch(animationActions.saveLocally());
      }, LOCAL_SAVE_DELAY);
    }

    return function cleanup() {
      clearTimeout(saveTimer.current);
    };
  }, [animation, enabled, dispatch]);

  return useCallback(
    function cancelPendingAutosave() {
      dispatch(editorActions.setDbSaveState(EDITOR_DB_SAVE_STATE.QUEUED));
      clearTimeout(saveTimer.current);
    },
    [dispatch],
  );
};
